export enum OrderAction {
  PURCHASE = 'PURCHASE',
  REDEEM = 'REDEEM'
}
